const GENERIC = 'Something went wrong. Please try again.';

/**
 * Turns a raw Google sign-in error (from the server or the browser) into a short, friendly
 * sentence. Setup or server details are never shown to the user; unknown errors get a generic message.
 */
export function friendlyAuthError(raw: string | undefined | null): string {
  const msg = (raw || '').toLowerCase();
  if (!msg) return GENERIC;
  if (msg.includes('rate limit') || msg.includes('too many'))
    return 'Too many attempts. Please wait a minute and try again.';
  if (
    msg.includes('failed to fetch') ||
    msg.includes('network') ||
    msg.includes('load failed') ||
    msg.includes('offline') ||
    msg.includes('timed out') ||
    msg.includes('timeout')
  )
    return "Can't reach LingoPing. Check your internet connection and try again.";
  // The browser cannot tell a blocked window from a closed one, so this message covers both.
  if (msg.includes('blocked'))
    return 'Sign-in was cancelled or blocked. Try again, and allow pop-ups if asked.';
  if (msg.includes('cancel') || msg.includes('closed') || msg.includes('did not approve'))
    return 'Sign-in was cancelled. Please try again when you are ready.';
  if (
    msg.includes('not enabled') ||
    msg.includes('could not be loaded') ||
    msg.includes('authorization page') ||
    msg.includes('provider')
  )
    return "Google sign-in isn't available right now. Please try again later.";
  if (msg.includes('not configured') || msg.includes('supabase'))
    return "Sign-in isn't available right now. Please try again later.";
  if (
    msg.includes('server') ||
    msg.includes('unexpected_failure') ||
    msg.includes('internal') ||
    /\b5\d\d\b/.test(msg)
  )
    return 'LingoPing had a problem signing you in. Please try again in a moment.';
  return GENERIC;
}
